import axios from "axios";
import { Message } from "element-ui";
let http = process.env.VUE_APP_BASE_URL
axios.defaults.baseURL = http
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.interceptors.request.use(
  function (config) {
    config.headers.token = localStorage.getItem("usertoken");
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    if (response.data.message == "token失效或者不存在") {
      localStorage.clear();
      Message({
        message: "请重新登录",
        type: "error",
      });
      window.location.href = "#/login";
    }
    if (response.data.code === 0) {
      return Promise.resolve(response);
    }else{
      if(response.data.message != "token失效或者不存在"){
        Message({
          type: "error",
          message: response.data.message,
        });
      }
    
      return Promise.reject(response);
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

function get(url, data) {
  return axios({
    url: http + url,
    method: "GET",
    params: data,
  });
}
function post(url, data) {
  return axios({
    url: http + url,
    method: "POST",
    data: data,
  });
}

function pay(data) {
  return new Promise((resolve,reject)=>{
    axios({
      url: http + "user/pay/creation",
      method: "POST",
      data: data,
    }).then((res) => {
      let str = res.data.data;
      if (str.id) {
          resolve()
      } else {
        const div = document.createElement("div");
        div.innerHTML = str;
        document.body.appendChild(div);
        document.forms[0].submit();
      }
    });
  })

}

// 获取教练信息
function Getcoach() {
  get("user/coach/findById", {
    id: localStorage.getItem("coach_id"),
  }).then((res) => {
    if (res.data.code == 0) {
      localStorage.setItem("userList", JSON.stringify(res.data.data));
    } else {
      Message({
        duration: 1000,
        message: "更新信息失败请重新登录",
        type: "error",
      });
    }
  });
}
export default {
  get,
  post,
  Getcoach,
  pay,
  axios
};
